export default function() {
    initializeMonthPicker();
    initializePayoutGrid();
}

const reportData = {};

function initializeMonthPicker() {
    const kendoMonthPicker = $('#month-picker')
        .kendoDatePicker({
            depth: 'year',
            start: 'year',
            format: 'MMMM yyyy',
            change: onMonthChange,
        })
        .data('kendoDatePicker');

    function onMonthChange() {
        const month = kendoMonthPicker.value();
        const periodYear = month.getFullYear();
        const periodMonth = month.getMonth() + 1;

        const filter = {
            logic: 'and',
            filters: [
                { field: 'PeriodYear', operator: 'eq', value: periodYear },
                { field: 'PeriodMonth', operator: 'eq', value: periodMonth },
            ],
        };

        reportData.approvalGridDataSource.filter(filter);
    }
}

function initializePayoutGrid() {
    reportData.approvalGridDataSource = new kendo.data.DataSource({
        serverFiltering: false,
        transport: {
            read: {
                type: 'get',
                url: '/Commissions/HrReport/Payouts',
            },
        },
        schema: {
            model: {
                fields: {
                    BranchName: {
                        type: 'string'
                    },
                    EmployeeName: {
                        type: 'string'
                    },
                    EmployeeNumber: {
                        type: 'string'
                    },
                    PeriodYear: {
                        type: 'number'
                    },
                    PeriodMonth: {
                        type: 'number'
                    },
                    PeriodMonthName: {
                        type: 'string',
                    },
                    CommissionDollarAmount: {
                        type: 'number'
                    }
                }
            }
        }
    });

    $('#payout-grid')
        .kendoGrid({
            dataSource: reportData.approvalGridDataSource,
            columns: [
                {
                    field: 'BranchName',
                    title: 'Branch',
                    editable: false,
                    headerAttributes: { style: 'white-space: normal' },
                    filterable: {
                        cell: {
                            showOperators: false
                        }
                    },
                },
                {
                    field: 'EmployeeName',
                    title: 'Employee Name',
                    editable: false,
                    headerAttributes: { style: 'white-space: normal' },
                    filterable: {
                        cell: {
                            showOperators: false
                        }
                    },
                },
                {
                    field: 'EmployeeNumber',
                    title: 'Employee Number',
                    editable: false,
                    headerAttributes: { style: 'white-space: normal' },
                    filterable: {
                        cell: {
                            showOperators: false
                        }
                    },
                },
                {
                    field: 'PeriodYear',
                    title: 'Year',
                    editable: false,
                    headerAttributes: { style: 'white-space: normal' },
                    filterable: {
                        cell: {
                            showOperators: false,
                            template: function(args) {
                                args.element.kendoNumericTextBox({
                                    format: '0',
                                    decimals: 0,
                                    step: 1,
                                });
                            },
                        },
                    },
                },
                {
                    field: 'PeriodMonthName',
                    title: 'Month',
                    editable: false,
                    headerAttributes: { style: 'white-space: normal' },
                    filterable: {
                        cell: {
                            showOperators: false
                        }
                    },
                },
                {
                    field: 'CommissionDollarAmount',
                    title: 'Commission Payout',
                    editable: false,
                    format: '{0:c}',
                    headerAttributes: { style: 'white-space: normal' },
                    filterable: {
                        cell: {
                            showOperators: false
                        }
                    },
                },
            ],
            columnMenu: true,
            filterable: {
                mode: 'row',
                extra: true,
                operators: {
                    number: {
                        eq: 'Is Equal To',
                        gte: 'Is Greater Than or Equal To',
                        lte: 'Is Less Than or Equal To'
                    },
                    string: {
                        contains: 'Contains',
                        startswith: 'Starts With'
                    }
                }
            },
            sortable: true,
        })
        .data('kendoGrid');
}
